"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./index.scss");
var sok_ui_1 = require("@caddigital/sok-ui");
var Icon_1 = require("components/Icon");
var languages_1 = require("utils/helpers/languages");
exports.default = (function (props) {
    var selectedLanguage = languages_1.languageData.find(function (l) { return l.code.toLowerCase() === props.languageCode.toLowerCase(); }) || languages_1.languageData[0];
    return (React.createElement(sok_ui_1.Dropdown2, { className: 'login-container-language-selector' },
        React.createElement(sok_ui_1.TextInput, { editable: false, className: 'language', value: selectedLanguage.name, icon: React.createElement(Icon_1.Icon, { className: 'fa-language' }) }),
        React.createElement(sok_ui_1.Dropdown2Menu, { className: 'login-container-language-selector-dropdown' }, languages_1.languageData.map(function (language, key) { return (React.createElement(sok_ui_1.Dropdown2MenuItem, { key: key, className: 'group-item', onClick: function () { return props.updateUserLanguage(language.code); } },
            React.createElement("span", { className: 'language' }, language.name))); }))));
});
